<template>
  <v-container grid-list-xl text-xs-center>
    <ReceiptViewer
      v-if="showDialog"
      :showDialog="showDialog"
      v-on:hide="showDialog = false"
      :receiptImage="receiptImageElement"
    />
    <v-layout row wrap>
      <v-flex xs4>
        <v-card elevation-24 style="padding: 20px; border: 1px;">
          <v-card-text>
            <h4 class="display-1 font-weight-bold">Receipt Search</h4>
            <v-text-field
              clearable
              v-model="agentReferenceNumber"
              label="Consumer's Reference Number"
              prepend-icon="mdi-barcode"
              type="text"
              color="black"
             
              @keypress.enter="searchReferenceNumber"
            ></v-text-field>
            <br />
            <v-btn @click="searchReferenceNumber" color="grey darken-2" large
              >Search</v-btn
            >
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "../store/helpers";
import moment from "moment";
import ReceiptViewer from "../components/ReceiptViewer";

export default {
  components: {
    ReceiptViewer
  },
  data() {
    return {
      kancel: "",
      agentReferenceNumber: "",
      showDialog: false,
      receiptImageElement: new Image(),
      receiptImageIsLoading: true
    };
  },
  computed: {
    ...mapGetters(["userToken", "selectedDashboard"]),
    ...mapFields([
      "reClaimed",
      "reClaimText",
      "referenceNumber",
      "receiptImageURL",
      "createdAt",
      "createdAtDate",
      "createdAtTime",
      "status",
      "id",
      "campaignTitle",
      "campaign_fk",
      "receiptNumber",
      "total",
      "campaignRetailers",
      "hasWallet",
      "products",
      "couponsToCreate",
      "hasEditableCoupons",
      "productImageURL",
      "coinImageURL",
      "detailsText",
      "campaignEndDate",
      "campaignStartDate",
      "processedProducts",
      "productTotal",
      "retailerFk",
      "customerToken",
      "selectedProducts",
      "rejectReason",
      "total",
      "receiptId",
      "vatNumber",
      "paymentAmount",
      "receiptDateTime",
      "prevReceipts",
      "usedReceipts",
      "customerInfo",
      "processHistory",
      "country",
      "used",
      "dupRefNum",
      "selectedCheckbox",
      "sendSftp",
      "sftpFile",
      "postCode",
      "ciuNumber",
      "retailerName",
      "retailerAddresss",
      "retailerCity",
      "allRetailerNames",
      "allRetailerAddresses",
      "allCiuNumbers",
      "paymentHistory",
      "paymentStatus",
      "clubCode",
      "fiscalId",
      "rppData"
    ])
  },
  methods: {
    ...mapActions([
      "getReceiptwithRefNumber",
      "getProductsList",
      "getDashboardData",
      "getPrevParticipations"
    ]),
    searchReferenceNumber() {
      this.getPrevParticipations({
        userToken: this.userToken,
        referenceNumber: this.agentReferenceNumber,
        dashboard: this.selectedDashboard
      }).then(prevParticipations => {
        if (prevParticipations.receipts) {
          this.prevReceipts = prevParticipations.receipts;
          this.usedReceipts = prevParticipations.usedReceipt;
          this.customerInfo = prevParticipations.customerInfo;
        }
      });
      this.getReceiptwithRefNumber({
        userToken: this.userToken,
        referenceNumber: this.agentReferenceNumber,
        dashboard: this.selectedDashboard
      }).then(async (res) => {
        const receipt = res.receipt;
        // console.log(">>>", res);

        const products = res.campaignProducts;
        if (this.selectedDashboard.isCroppable) {
          this.receiptImageURL = receipt.receiptFullImageURL;
        } else {
          this.receiptImageURL = receipt.receiptImageURL;
        }
        this.productImageURL = receipt.productImageURL;
        this.coinImageURL = receipt.coinImageURL;
        // this.receiptImageURL = receipt.receiptFullImageURL;
        //   this.receiptImageURL = receipt.receiptImageURL;

        // this.showDialog = true;
        this.country = receipt.country;
        this.used = receipt.rejectReason === "used" ? true : false;
        this.vatNumber = receipt.extra && JSON.parse(receipt.extra).vatNumber ? JSON.parse(receipt.extra).vatNumber : ''
        this.selectedCheckbox =
          receipt.extra && JSON.parse(receipt.extra).selectedCheckbox
            ? JSON.parse(receipt.extra).selectedCheckbox
            : {
                vatMetro: { value: false, status: 0 },
                rossmannDiscount: { value: false, status: 0 }
              };
        this.dupRefNum = receipt.erroringRefNumbers;
        const payload = {
          userToken: this.userToken,
          dashboard: this.selectedDashboard,
          campaign_fk: receipt.campaign_fk
        };
        try {
          await this.getDashboardData(payload);
        } catch (e) {
          console.log("GET DASHBOARD DATA ERROR:: ", e);
          return
        }
        this.img = new Image();
        this.receiptImageIsLoading = true;
        this.img.onload = () => {
          this.paymentAmount = receipt.paymentAmount;
          this.receiptImageIsLoading = false;
          this.receiptImageElement = this.img;
        };

        this.img.src = `${this.receiptImageURL}?${new Date().getTime()}`;
        this.createdAt = receipt.createdAt;
        this.campaignTitle = receipt.campaignTitle;
        this.campaign_fk = receipt.campaign_fk;
        this.receiptDateTime = receipt.receiptDateTime;
        this.extra = receipt.extra ? JSON.parse(receipt.extra) : {};
        if (receipt.processHistory) {
          try {
            this.processHistory = JSON.parse(receipt.processHistory);
          } catch {
            console.log("REMOVED HISTORY");
            this.processHistory = [];
          }
        }
        if (this.selectedDashboard.extraRetailerField && receipt.location) {
          try {
            const {cif_number, retailer_name, retailer_address, retailer_city} = JSON.parse(receipt.location);
            this.ciuNumber = cif_number;
            this.retailerName = retailer_name;
            this.retailerAddresss = retailer_address;
            this.retailerCity = retailer_city;
          } catch (e) {console.log(e)}
        }
        console.log("HIST AGENT: ", this.processHistory);
        // const isValidDate = moment(
        //   receipt.identifiedDate,
        //   "YYYY-MM-DD"
        // ).isValid();
        // if (isValidDate) {
        // this.createdAtDate = moment
        //   .utc(receipt.identifiedDate)
        //   .format("YYYY-MM-DD");
        // } else {
        // this.createdAtDate = "";
        // }
        this.createdAtTime = moment(receipt.updatedAt).format("HH:MM");
        this.createdAtDate = receipt.createdAt;
        this.status = receipt.status;
        this.sendSftp = receipt.sendSftp;
        this.sftpFile = receipt.sftpFile;
        this.id = receipt.receiptToken;
        this.customerToken = receipt.customerToken;
        this.referenceNumber = receipt.referenceNumber;
        this.receiptNumber = receipt.identifiedId;
        this.total = receipt.total;
        this.postCode = receipt.postCode;
        this.receiptId = receipt.receiptId;
        this.couponsToCreate = receipt.couponsPerReceipt;
        this.detailsText = receipt.detailsText;
        this.retailerFk = receipt.retailer;
        if (receipt.paymentHistory) this.paymentHistory = receipt.paymentHistory;
        if (receipt.paymentStatus) this.paymentStatus = receipt.paymentStatus;
        if (typeof this.retailerFk === "string") {
          this.retailerFk = parseInt(this.retailerFk);
        }
        this.campaign_fk = receipt.campaignId;
        this.rejectReason = receipt.rejectReason;
        this.paymentAmount = receipt.paymentAmount;
        if (receipt.clubCode) this.clubCode = receipt.clubCode;
        if (receipt.fiscalId) this.fiscalId = receipt.fiscalId;
        if (receipt.rppData) this.rppData = receipt.rppData;
        this.campaignEndDate = moment(receipt.campaignEndDate).format(
          "DD-MM-YYYY"
        );
        this.campaignStartDate = moment(receipt.campaignStartDate).format(
          "DD-MM-YYYY"
        );
        this.hasWallet = receipt.hasWallet;
        if (receipt.selectedProducts) {
          this.selectedProducts = JSON.parse(receipt.selectedProducts);
          // console.log("PPPP", this.selectedProducts);
        }
        if (this.hasWallet) {
          const identifications = JSON.parse(receipt.identifications);

          if (identifications) this.productTotal = identifications.productTotal;
        }

        this.getProductsList({
          dashboard: this.selectedDashboard,
          campaignId: receipt.campaignId
        }).then(products => {
          // console.log("PRODUCTS", products);
          if (products.length) {
            this.products = products;
            this.processedProducts = [];
            this.showDialog = true;
          } else if (this.selectedDashboard.campaignId === 'pg-ro') {
            this.products = products
            this.processedProducts = []
            this.showDialog = true
          }
        });
        if (this.selectedDashboard.extraRetailerField)
          this.getLocationsList({
            dashboard: this.selectedDashboard,
            campaignId: receipt.campaign_fk
          }).then(locations => {
            this.allRetailerNames = locations.retailerNames,
            this.allRetailerAddresses = locations.retailerAddresses,
            this.allCiuNumbers = locations.cifNumbers
          })

        if (this.couponsToCreate === -1) {
          this.hasEditableCoupons = true;
          this.couponsToCreate = 1;
        }
        this.campaignRetailers = res.campaignRetailers;

        if (receipt.hasWallet) {
          this.hasWallet = receipt.hasWallet;
        }
        // console.log("PPP", receipt.selectedProducts);
        if (res.campaignProducts && res.campaignProducts.length) {
          this.products = res.campaignProducts;
          this.processedProducts = [];
          if (
            "processedProducts" in receipt &&
            receipt.processedProducts != null
          ) {
            const parsedSelecteds = JSON.parse(receipt.processedProducts);
            parsedSelecteds.forEach(selectedProduct => {
              console.log("SELECTEd PPP", selectedProduct);
              const product = {
                groupingId: selectedProduct.groupingId.split("$$")[1],
                items: selectedProduct.items,
                total: selectedProduct.total
              };
              this.processedProducts.push(product);
              const foundProduct = this.products.find(
                e => e.ean === product.groupingId
              );
              foundProduct.count = product.items;
            });
          }
        }
      });
    }
  },
  mounted() {
    this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));
    if ("name" in this.selectedDashboard === false) {
      const dashboard = JSON.parse(localStorage.selectedDashboard);
      this.$store.commit("setDashboard", dashboard);
    }
  }
};
</script>
